const CTA = ({ text }) => {
  return (
    <div className="w-full flex justify-center items-center">
      <div className="relative group">
        <div className="relative w-72 h-14 overflow-hidden rounded-xl bg-black z-10 shadow-lg">
          {/* Light sweep animation */}
          <div className="absolute z-10 -translate-x-44 group-hover:translate-x-[30rem] transition-all duration-700 h-full w-44 bg-gradient-to-r from-blue-400 to-white/10 opacity-30 -skew-x-12"></div>

          {/* Button content */}
          <div className="absolute flex items-center justify-center text-white z-[1] rounded-2xl inset-0.5 bg-black">
            <button
              name="text"
              onClick={() => { const section = document.getElementById("contact"); if (section) { section.scrollIntoView({ behavior: "smooth" }); }}}
              className="font-semibold text-xl h-full w-full px-16 py-3 rounded-xl bg-black transition-colors duration-300 hover:text-blue-300"
            >
              {text}
            </button>
          </div>

          {/* Glow blur effect */}
          <div className="absolute w-full h-[100px] bg-gradient-to-r from-blue-500 to-sky-400 blur-[40px] opacity-50 group-hover:blur-[60px] transition-all duration-1000" />
        </div>
      </div>
    </div>
  );
};

export default CTA;
